import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
// - pages
import { ClsdataComponent } from './components/pages/clsdata/clsdata.component';
import { ClsgroupservicesComponent } from './components/pages/clsgroupservices/clsgroupservices.component';

import { NotfoundComponent } from './components/pages/notfound/notfound.component';
// - shared
import { ArticleViewComponent } from './components/shared/article-view/article-view.component';
import { EventViewComponent } from './components/shared/event-view/event-view.component';

// fail gracefully - to show page.
import { UnsupportedBrowserComponent } from './components/shared/unsupported-browser/unsupported-browser.component';

import { Angulartics2Module } from 'angulartics2';
import { DRiskComponent } from './components/pages/d-risk/d-risk.component';

const routes: Routes = [
  // { path: '', redirectTo: '/home', pathMatch: 'full'},
  { path: '', redirectTo: 'ordering/login', pathMatch: 'full', data: { animation: 'HOME', project_name: 'FrontEnd' } },

  { path: 'data', component: ClsdataComponent, data: { animation: 'DT' } },
  { path: 'groupservices', component: ClsgroupservicesComponent, data: { animation: 'GS' } },
  { path: 'd-risk', component: DRiskComponent, data: { animation: 'DR' } },
  // - news
  { path: 'news/:url', component: ArticleViewComponent, data: { animation: 'OTHER' } },
  // - events
  { path: 'events/:url', component: EventViewComponent, data: { animation: 'OTHER' } },
  // - others
  { path: 'browser-support', component: UnsupportedBrowserComponent, data: { animation: 'OTHER' } },
  // - newcase
  {
    path: 'ordering',
    loadChildren: () => import('./ordering-platform/ordering-platform-routing.module').then(m => m.OrderingPlatformRoutingModule)
  },
  { path: 'login/resetpassword', redirectTo: 'ordering/login/resetpassword', pathMatch: 'full' },

  { path: '**', component: NotfoundComponent, data: { animation: 'OTHER' } },
];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      preloadingStrategy: PreloadAllModules
    }),
    Angulartics2Module.forRoot()
  ],
  providers: [
    {
      provide: 'externalUrlRedirectResolver',
      useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        //clsrs want their route to redirect to an external site
        window.location.href = (route.data as any).externalUrl;
      }
    }
  ]
})
export class AppRoutingModule { }
